import React, { PureComponent } from 'react';
import InstallableAppCenterFooter, { BoldHeader } from './InstallableAppCenterFooter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class InstallableAppAlreadyInstalledMessage extends PureComponent {
  render() {
    return /*#__PURE__*/_jsxs(InstallableAppCenterFooter, {
      children: [/*#__PURE__*/_jsx(BoldHeader, {
        children: "We're seeing double!"
      }), /*#__PURE__*/_jsxs("div", {
        children: ["This app is already added to ", this.props.hostConfig.installationLocation, "."]
      })]
    });
  }
}